import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PaginaVisitantesComponent } from './pagina-visitantes/pagina-visitantes.component';
import { DetalleVisitanteComponent } from './detalle-visitante/detalle-visitante.component';

const rutas: Routes = [
  { path: 'nuevo', component: DetalleVisitanteComponent },
  { path: ':id', component: DetalleVisitanteComponent },
  { path: '', component: PaginaVisitantesComponent }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild( rutas )
  ],
  exports: [
    RouterModule
  ]
})
export class VisitantesRoutingModule { }
